module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-ford.831fa8bc.png";